import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton, Tooltip } from "@mui/material/node";
import { useTheme } from '@mui/material/styles';

export const ResetLayoutButton = (props) => {
    const theme = useTheme();
    return (
        <Tooltip title="Reset layout">
        <IconButton aria-label="Refresh layout" onClick={(e) => { props.action();}} color="inherit" sx={{ m: 0.5 }}>
            <RefreshIcon sx={{color: theme.palette.menuIcon.main}} />
        </IconButton>
        </Tooltip>
    );
}
